import { isTransient } from '../http/helper';
import { Deferred } from './Deferred';

export var async = function async(apiCall) {
  var deferred = Deferred();
  doAsync(apiCall, deferred);
  return deferred.promise;
};

var doAsync = function doAsync(apiCall, deferred) {
  var retries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  apiCall().then(function (response) {
    return deferred.resolve(response.data);
  }, function (error) {
    if (isTransient(error) && retries < 3) {
      setTimeout(function () {
        doAsync(apiCall, deferred, retries + 1);
      }, 200);
    } else {
      deferred.reject(error);
    }
  });
};